/* Core & libraries */
import React, { useCallback, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import {
  TRAVELER_DETAILS_UPDATE_ENDPOINT
} from "../endpoints/endpoints";
import { useUserContext } from "../contexts/userContext";
import { useNotificationContext } from '../contexts/notificationContext';
import { useLocation } from "react-router-dom";

/* Components */
/* Styles */

export const useTravelerService = (userEntityId, defaultTravelerDetails = {}) => {
  const [travelerDetails, setTravelerDetails] = useState(defaultTravelerDetails);
  const { genericApiFetch } = useGenericApiFetch();
  const { setNotification } = useNotificationContext();
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  useEffect(() => {
    (async () => {
      await getTravelerDetails(userEntityId || userDetails?.userInfo?.userEntityId);
    })();
  }, []);

  const getTravelerDetails = async (userEntityId) => {
    const response = await genericApiFetch({
      url: TRAVELER_DETAILS_UPDATE_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()).replace("{userEntityId}", userEntityId),
      method: "GET",
    });
    if (response.success) {
      setTravelerDetails({
        ...response.data,
        firstName: response.data?.firstName || defaultTravelerDetails.firstName,
        lastName: response.data?.lastName || defaultTravelerDetails.lastName,
      });
      if (!response.data.companyInfo) {
        setNotification(
          "refresh",
          <FormattedMessage id="notifications.genericTitle" />,
          <FormattedMessage id="notifications.genericDescription" />
        );
      }
      return true;
    }
    setNotification(
      "refresh",
      <FormattedMessage id="notifications.genericTitle" />,
      <FormattedMessage id="notifications.genericDescription" />
    );
    return false;
  };

  const refetchTravelerDetails = useCallback((updatedData = {}) => {
    setTravelerDetails(travelerDetails => ({ ...travelerDetails, ...updatedData }));

    return getTravelerDetails(userEntityId);
  }, [userEntityId]);

  return {
    travelerDetails,
    refetchTravelerDetails
  };
}

export const useTravelerServiceWithLocationData = (userEntityId) => {
  const location = useLocation();

  return useTravelerService(userEntityId, location?.state?.userRowDetails);
}